export default __webpack_public_path__ + "static/media/260.33e5f57d.png";